'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.mapTransitionsToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

var _helpers = require('../../transitions/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  '& .overlay': {
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    bottom: 0,
    display: 'flex',
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 1000
  },
  '& .dialog': {
    backgroundColor: '#ffffff',
    margin: 'auto',
    padding: '15px',
    maxWidth: '90%',
    width: '500px'
  },
  '& .title': {
    fontSize: '22px',
    fontWeight: 'bold'
  },
  '& .content, & .contentchildren': {
    margin: '15px 0'
  },
  '& .actions': {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '15px'
  },
  '& .actions .confirm': {
    marginLeft: 'auto'
  },
  '& .actions button': {
    margin: 0
  }
};

var mapTransitionsToStyle = exports.mapTransitionsToStyle = function mapTransitionsToStyle(_ref) {
  var _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === undefined ? 150 : _ref$timeout;

  var enter = (0, _helpers.getEnter)(timeout);
  var exit = (0, _helpers.getExit)(timeout);

  return {
    // Fade overlay
    '& .fade-slide-enter': {
      opacity: 0
    },
    '& .fade-slide-enter.fade-slide-enter-active': {
      opacity: 1,
      transition: 'opacity ' + enter + 'ms ease-out'
    },
    '& .fade-slide-exit': {
      opacity: 1
    },
    '& .fade-slide-exit.fade-slide-exit-active': {
      opacity: 0,
      transition: 'opacity ' + exit + 'ms ease-in'
    },
    // Slide dialog window
    '& .fade-slide-enter .dialog': {
      transform: 'translate(0%, -100%)'
    },
    '& .fade-slide-enter.fade-slide-enter-active .dialog': {
      transform: 'translate(0%, 0%)',
      transition: 'transform ' + enter * (2 / 3) + 'ms ease-out ' + enter / 3 + 'ms'
    },
    '& .fade-slide-exit .dialog': {
      transform: 'translate(0%, 0%)'
    },
    '& .fade-slide-exit.fade-slide-exit-active .dialog': {
      transform: 'translate(0%, -100%)',
      transition: 'transform ' + exit * (2 / 3) + 'ms ease-in'
    }
  };
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(props, theme) {
  return (0, _extends3.default)({
    '& .dialog': {
      boxShadow: theme.boxShadow,
      padding: theme.paddingBase * 15 + 'px'
    },
    '& .title': {
      fontFamily: theme.font.headerFamily,
      textTransform: 'uppercase'
    }
  }, (0, _objectResolvePath2.default)(theme, 'Dialog.css'));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Dialog/Dialog.style.js
// module id = 459
// module chunks = 0